export default function QuizForm({
  isForEdit = false,
  question,
  setQuestion,
  options,
  setOptions,
  handleSubmit,
  setSelectedVideo,
  selectedVideo,
  videos,
}) {
  const handleChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleOptionChange = (id, value) => {
    const updatedOptions = options.map((option) =>
      option.id === id ? { ...option, option: value } : option
    );
    setOptions(updatedOptions);
  };

  const handleIsCorrectChange = (id) => {
    const updatedOptions = options.map((option) =>
      option.id === id
        ? { ...option, isCorrect: true }
        : { ...option, isCorrect: false }
    );
    setOptions(updatedOptions);
  };

  const handleVideoSelect = (e) => {
    const { value } = e.target;
    if (!value) {
      setSelectedVideo(null);
      return;
    }

    const selectedVideo = videos.find((video) => video.id === Number(value));
    setSelectedVideo(selectedVideo);
  };

  return (
    <form
      className="mt-8 space-y-6 mx-auto max-w-md px-5 lg:px-0"
      action="#"
      method="POST"
      onSubmit={handleSubmit}
    >
      <h1 className="text-xl text-center font-bold">
        {isForEdit ? "Edit Quiz" : "Add Quiz"}
      </h1>
      <div className="form-group">
        <label htmlFor="question">Question</label>
        <input
          id="question"
          name="question"
          type="text"
          onChange={handleChange}
          value={question}
          required
          className="login-input rounded-t-md"
          placeholder="quiz question"
        />
      </div>
      <div className="form-group">
        <label htmlFor="title">Quiz Video</label>
        <select
          name="video"
          id="video"
          className="login-input rounded-t-md"
          required
          onChange={handleVideoSelect}
          value={selectedVideo?.id}
        >
          <option value="" selected>
            select quiz video
          </option>
          {videos?.map((video) => (
            <option value={video.id} key={video.id}>
              {video.title}
            </option>
          ))}
        </select>
      </div>
      {/* create a divider in tailwind css */}
      <hr />

      <div className="form-group">
        <h1 className="text-center mb-3">Quiz Options</h1>
        {options.map(({ id, option, isCorrect }) => (
          <div key={id} className="mb-3">
            <label>
              Option {id}:
              <input
                type="text"
                name="option"
                id="option"
                className="login-input rounded-t-md"
                value={option}
                required
                onChange={(e) => handleOptionChange(id, e.target.value)}
              />
            </label>
            <label>
              Is Correct?
              <input
                type="checkbox"
                checked={isCorrect}
                className="ml-2"
                onChange={() => handleIsCorrectChange(id)}
              />
            </label>
          </div>
        ))}
      </div>

      <button
        type="submit"
        className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
      >
        Submit
      </button>
    </form>
  );
}
